import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Divider, Menu, MenuItem, ListSubheader, ListItemIcon, Fade, darken } from '@mui/material'
import { DynamicButton, DynamicButtonProps } from '../buttons/DynamicButton'
import { Icon } from './Icon'

type Props = DynamicButtonProps & {
  options?: { label: string; value: string; color?: string; disabled?: boolean }[]
  onClick: (value?: string) => void
}

export const NetworksAddMenu: React.FC<Props> = ({ options = [], onClick, ...props }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [menuWidth, setMenuWidth] = useState<number>()

  const clickHandler = event => {
    setAnchorEl(event.currentTarget)
    setMenuWidth(event.currentTarget.offsetWidth)
  }

  const closeHandler = () => {
    setAnchorEl(null)
  }

  const selectHandler = (value?: string) => {
    closeHandler()
    onClick(value)
  }

  return (
    <>
      <DynamicButton
        {...props}
        onClick={clickHandler}
        icon={props.icon || 'caret-down'}
        iconType={props.size === 'icon' ? undefined : 'solid'}
      />
      <Menu
        elevation={2}
        sx={theme => ({
          '& .MuiList-root': {
            paddingTop: '4px',
            ...(props.color === 'primary' ? { backgroundColor: theme.palette.primary.main } : {}),
          },
          '& .MuiListSubheader-root + .MuiDivider-root': { marginTop: '2px' },
          ...(props.color === 'primary'
            ? {
                '& .MuiListItem-root': {
                  color: theme.palette.alwaysWhite.main,
                  fontWeight: '500',
                  '&:hover': { backgroundColor: darken(theme.palette.primary.main, 0.1) },
                  '&:focus': { backgroundColor: darken(theme.palette.primary.main, 0.1) },
                  '&:focus:hover': { backgroundColor: darken(theme.palette.primary.main, 0.15) },
                },
              }
            : {}),
        })}
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={closeHandler}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{ style: { minWidth: menuWidth } }}
        TransitionComponent={Fade}
        disableAutoFocusItem
      >
        {!!options.length && (
          <ListSubheader disableGutters disableSticky>
            Networks
          </ListSubheader>
        )}
        {!!options.length &&
          options.map(option => (
            <MenuItem
              dense
              key={option.value}
              color={option?.color}
              onClick={() => selectHandler(option.value)}
              value={option.value}
              disabled={option.disabled}
              sx={{ color: option.color + '.main' }}
            >
              {option.label}
            </MenuItem>
          ))}
        {!!options.length && <Divider />}
        <ListSubheader disableGutters disableSticky>
          Create new
        </ListSubheader>
        <MenuItem dense component={Link} to="/networks/add">
          <ListItemIcon>
            <Icon name="plus" />
          </ListItemIcon>
          Network &nbsp;
        </MenuItem>
      </Menu>
    </>
  )
}

